import OIncomingCallModal from './index.vue';

OIncomingCallModal.install = app => {
  app.component(OIncomingCallModal.name, OIncomingCallModal);
};

export default OIncomingCallModal;
